export const GET_SUPPLIER_REPS = 'GET_SUPPLIER_REPS';
export const SET_SUPPLIER_REPS = 'SET_SUPPLIER_REPS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_SUPPLIER_REP = 'SET_SUPPLIER_REP';
export const ADD_SUPPLIER_REP = 'ADD_SUPPLIER_REP';
export const EMPTY_SUPPLIER_REP = 'EMPTY_SUPPLIER_REP';
export const DELETE_SUPPLIER_REP = 'DELETE_SUPPLIER_REP';
export const EDIT_SUPPLIER_REP = 'EDIT_SUPPLIER_REP';
export const UPDATE_SUPPLIER_REP = 'UPDATE_SUPPLIER_REP';
export const SET_SUPPLIER_REP_FILTER = 'SET_SUPPLIER_REP_FILTER';